import type { DomainModule } from "@exopengithub/planning-api-shared";
import { createEntityAdapter } from "@reduxjs/toolkit";

export const modulesAdapter = createEntityAdapter<DomainModule>();

export const modulesSelectors = modulesAdapter.getSelectors();
